import { ExpressionRuleEditor } from "../ExpressionRuleEditor";
import { ExpressionPiece } from "../../Builder/ExpressionStyles";
import { ExpressionValueRenderer } from "../../Builder/ExpressionValueRenderer";
import React from "react";
import { DivideExpression } from "../../../rule-engine-core/Expressions/Expressions/Math/DivideExpression";
import styled from "styled-components";
import { ExpressionReactContext, ExpressionRenderType } from "../../Structure/ExpressionReactContext";
import { UIStyleConstants } from "../../../rule-engine-core/Common/UIStyleConstants";
import type { AppGlueAny } from "../../../rule-engine-core/Common/AppGlueAny";

export class DivideExpressionEditor extends ExpressionRuleEditor<DivideExpression> {
    render() {
        return (
            <ExpressionPiece>
                <DivisionDiv>
                    <TopDiv>
                        <ExpressionValueRenderer el={this.ruleData!.divideValue!} />
                    </TopDiv>
                    <BottomDiv>
                        <ExpressionValueRenderer el={this.ruleData!.divideBy!} />
                    </BottomDiv>
                </DivisionDiv>
            </ExpressionPiece>
        );
    }
}

const StyledDivisionDiv = styled.div<{ renderType: ExpressionRenderType }>`
    display: flex;
    flex-direction: column;

    ${(props) =>
        props.renderType === ExpressionRenderType.FULL
            ? `
                font-size:      18px;
                border-left: 1px solid darkgray;
                border-right: 1px solid darkgray;
                border-radius: 10px;
                margin-left: 10px;
                margin-right: 10px;
                padding-left: 10px;
                padding-right: 10px;
                padding-top: 2px;
                padding-bottom: 2px;
            `
            : `
            jusity-content: center;
        `}
`;

const DivisionDiv = (props: { children?: AppGlueAny }) => {
    const context = React.useContext(ExpressionReactContext);
    return (
        <StyledDivisionDiv
            {...props}
            renderType={context.renderType}
        />
    );
};

const StyledTopDiv = styled.div<{ renderType: ExpressionRenderType }>`
    ${(props) =>
        props.renderType === ExpressionRenderType.FULL
            ? `
                padding-bottom: 5px;

                margin-top: 5px;
                margin-bottom: 5px;
                margin-left: 5px;
                margin-right: 5px;
                width: 100%;
                border-bottom: 3px solid  ${UIStyleConstants.GRAY_COLOR};

        `
            : `
                border-bottom: 2px solid  ${UIStyleConstants.GRAY_COLOR};
                padding-bottom: 5px;
            `}
    > div {
        justify-content: center;
    }
`;
const TopDiv = (props: { children?: AppGlueAny }) => {
    const context = React.useContext(ExpressionReactContext);
    return (
        <StyledTopDiv
            {...props}
            renderType={context.renderType}
        />
    );
};

const StyledBottomDiv = styled.div<{ renderType: ExpressionRenderType }>`
    width: 100%;

    ${(props) =>
        props.renderType === ExpressionRenderType.FULL
            ? `
                margin: 5px;
            `
            : `
                padding-top: 5px;
            `}
    > div {
        justify-content: center;
    }
`;
const BottomDiv = (props: { children?: AppGlueAny }) => {
    const context = React.useContext(ExpressionReactContext);
    return (
        <StyledBottomDiv
            {...props}
            renderType={context.renderType}
        />
    );
};
